import ScrollMagic from 'scrollmagic';
const Masonry = require('masonry-layout');

$(() => {
    const controller = new ScrollMagic.Controller();
    const msnry = new Masonry( '.js-news-items', {
        itemSelector: '.js-news-item',
    });

    $(window).on('resize', () => {
        msnry.layout();
    });

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__media-news',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__media-news .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);
})



// WEBPACK FOOTER //
// ./app/scripts/pages/about/media.js